/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
    id = id || 'id'
    parentId = parentId || 'parentId'
    children = children || 'children'
    rootId = rootId || '0';
    //对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data))
        //循环所有项
    const treeData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => {
            //返回每一项的子级数组
            return father[id] === child[parentId]
        });
        // eslint-disable-next-line no-unused-expressions
        branchArr.length > 0 ? father.children = branchArr : '';

        if (father.children && father.children.length === 0) {
            delete father.children
        }
        //返回第一层
        return father[parentId] === rootId;
    });
    return treeData !== '' ? treeData : data;
}
/**
 * 复制json对象
 * @param {*} data 数据源
 *
 */
export function cloneData(data) {
    return JSON.parse(JSON.stringify(data))
}


/**
	 * 生成随机字符串方法
	 * @param {Number} len
	 * */
 export const randomString = (len = 32) => {
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}


/**
 * 图片转base64方法
 *
 */
export const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}


/**
 * 生成从minNum到maxNum的随机数
 */
export const randomNum = (minNum, maxNum) => {
    if (maxNum) return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    return parseInt(Math.random() * minNum + 1, 10);
}


/**
 * 处理空数据
 * dataOfNull
*/
export const dataOfNull = (val) => {
    if (val == null || val === '') return '-';
    return val;
}



/**
 * toFloatFilter
 * 将数字转为字符串，并保留2位小数
 * */
 export const toFloatFilter = (val) => {
    if (!val) return '0.00';
    let _val = Number(val);
    if(isNaN(val)) return val;
    _val = _val.toString();
    const _dotIndex = _val.indexOf('.');
    let dotStr = _val.substring(_dotIndex + 1);
    if(_dotIndex === -1 || (_dotIndex > 0 && dotStr.length === 1)) return Number(_val).toFixed(2);
    return _val;
};
